<template>
  <div class="payment-method-cards" data-test="payment-method-details">
    <error-notification :errorCode="pageDetails.errorCode"></error-notification>
    <div v-if="onMobileDevice()" class="row">
      <div class="col-sm-12">
        <a
          v-bind:href="orderDetails.intentUrl"
          class="btn btn-cta btn-block"
          style="margin-top: 20px"
          >{{ $t("paymentdetails.payWithApp") }}</a
        >
      </div>
    </div>
    <div v-else style="margin-top: -10%" class="row">
      <div class="col-sm-12">
        <img width="125px" height="125px" v-bind:src="orderDetails.qrUrl" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="separator" data-test="separator-element">
          {{ $t("seperator") }}
        </div>
      </div>
    </div>
    <ValidationObserver ref="observer">
      <div style="margin-top: 5%" class="row">
        <div v-if="!cse" class="col-sm-12 text-center">
          <span v-if="!cse"
            >Something went wrong, you're not able to pay with Bancontact in
            combination with card input.<br />Please use the QR or try again
            later.</span
          >
        </div>
        <div v-if="cse" class="col-sm-12 text-left">
          <form>
            <legend>{{ $t("paymentdetails.cards.title") }}</legend>
            <div class="row">
              <div class="col-sm-12">
                <ValidationProvider rules="required">
                  <card-holder
                    slot-scope="{ errors, flags }"
                    v-model="form.nameOnCard"
                    :messages="errors"
                    :flags="flags"
                  ></card-holder>
                </ValidationProvider>
                <ValidationProvider rules="required|luhn">
                  <bancontact-number
                    @updatecc="updateCC"
                    slot-scope="{ errors, flags }"
                    v-model="form.cardNumber"
                    :messages="errors"
                    :flags="flags"
                  >
                  </bancontact-number>
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <ValidationProvider rules="required|is_not:MM">
                  <expiration-month
                    slot-scope="{ errors, flags }"
                    v-model="form.expirationMonth"
                    :messages="errors"
                    :flags="flags"
                  ></expiration-month>
                </ValidationProvider>
              </div>
              <div class="col-sm-6">
                <ValidationProvider rules="required|is_not:YYYY">
                  <expiration-year
                    slot-scope="{ errors, flags }"
                    v-model="form.expirationYear"
                    :messages="errors"
                    :flags="flags"
                  ></expiration-year>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </div>
      </div>
    </ValidationObserver>
    <box-footer>
      <button
        v-if="cse"
        class="btn btn-cta"
        @click="pay()"
        data-test="pay-button"
      >
        {{ $t("paymentdetails.pay") }}
      </button>
    </box-footer>
  </div>
</template>

<script>
import errorNotification from "@/components/form/error-notification.vue";
import bancontactNumber from "@/components/form/bancontact-number.vue";
import cardHolder from "@/components/form/card-holder.vue";
import expirationMonth from "@/components/form/expiration-month.vue";
import expirationYear from "@/components/form/expiration-year.vue";

import boxFooter from "@/components/box-footer.vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import "@/utils/validator-luhn.js";

import isMobile from "ismobilejs";
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "paymentMethodBancontact",
  data() {
    return {
      form: {
        nameOnCard: "",
        issuer: "",
        cardNumber: "",
        expirationMonth: "MM",
        expirationYear: "YYYY",
      },
      cse: false,
      interval: null,
    };
  },
  components: {
    errorNotification,
    boxFooter,
    ValidationProvider,
    ValidationObserver,
    bancontactNumber,
    cardHolder,
    expirationMonth,
    expirationYear,
  },
  created() {
    this.checkStatus();
    if (this.pageDetails.clientSideEncryption) {
      if (this.pageDetails.clientSideEncryption.upstream === "PS") {
        if (
          this.pageDetails.clientSideEncryption.javaScript !== null &&
          Array.isArray(this.pageDetails.clientSideEncryption.javaScript)
        ) {
          this.pageDetails.clientSideEncryption.javaScript.forEach((value) => {
            console.log(value);
            let externalScript = document.createElement("script");
            externalScript.setAttribute("src", value);
            document.head.appendChild(externalScript);
          });
          this.interval = setInterval(() => {
            if (typeof cseEncrypt === "function") {
              this.cse = true;
              clearInterval(this.interval);
            }
          }, 100);
        }
      }
    }
  },
  computed: {
    ...paymentNS.mapGetters(["pageDetails"]),
    ...paymentNS.mapGetters(["orderDetails"]),
  },
  methods: {
    ...paymentNS.mapActions(["getPollingState"]),
    ...paymentNS.mapActions(["updateState"]),
    ...paymentNS.mapMutations(["setLoading", "setErrorCode"]),
    updateCC(value) {
      this.form.cardNumber = value.cardNumber;
    },
    onMobileDevice() {
      const agent = navigator.userAgent;
      const mobile = isMobile(agent);

      return mobile.any;
    },
    async pay() {
      this.setErrorCode(null);
      if (this.cse) {
        const encrypted = cseEncrypt(
          this.form.nameOnCard,
          this.form.cardNumber.replace(/ /g, ""),
          this.form.expirationMonth,
          this.form.expirationYear,
          this.form.cvv
        );

        console.log(encrypted);
        const params = {
            path: "provide-payment-details",
            data: {
              paymentMethod: "MISTERCASH",
              paymentDetails: {
                issuer: "MISTERCASH",
                encryptedData: encrypted,
              },
            },
          },
          isValid = await this.$refs.observer.validate();
        if (isValid) this.updateState(params);
      }
    },
    checkStatus() {
      const poll = () => {
        this.getPollingState().then((result) => {
          switch (result.page) {
            case "payment-success":
              window.location.href = result.pageDetails.url;
              break;
            default:
              setTimeout(poll, 2000);
              break;
          }
        });
      };
      // Start polling the payment status.
      setTimeout(poll, 5000);
    },
  },
};
</script>
